/** TOP のシェルと portal UI で共有するテーマモード属性名。 */
export const DASHBOARD_THEME_MODE_ATTRIBUTE = "data-dashboard-theme-mode";
